<template>
  <div class="evalue-main">
    <div class="order-evalue">
      <div class="orderTitle">您对商家/菜品满意吗？</div>
      <div
        v-for="item in UpdateData.showViewData && UpdateData.showViewData.items"
        :key="item.code"
      >
        <common-component
          :readOnly="true"
          :key="item.code"
          :item="item"
          @changeSorce="onChangeItem($event, item)"
          @changeText="changeText($event, item)"
          @changeUploadImg="changeUploadImg($event, item)"
          @deleteImg="changeDeleteImg($event, item)"
        />
      </div>
    </div>
    <div class="menu-evalue" v-for="item in orderItems" :key="item.productId">
      <div>
        <div class="order-item-info">
          <div class="order-item-title">{{ item.productName }}</div>
          <div class="order-item-money">￥{{ item.price / 100 }}</div>
          <div class="order-item-quantity">×{{ item.quantity }}</div>
        </div>
        <div
          v-for="item1 in UpdateData.orderItemShowViewData &&
          UpdateData.orderItemShowViewData.items"
          :key="item1.code"
        >
          <common-component
            :readOnly="true"
            :key="item1.code"
            :item="item1"
            @changeSorce="changeOrderItems($event, item1, item)"
          />
        </div>
      </div>
    </div>
    <div class="submit-bottom">
      <div class="submit-btn" @click="handleSubmitEvalue">提交</div>
    </div>
  </div>
</template>

<script>
import until from "../../utils/filter";
export default {
  data() {
    return {
      oid: "",
      UpdateData: {
        showViewData: {},
        orderItemShowViewData: {},
      },
      orderItems: [],
      commentItems: [],
      orderCommentItems: [],
      uploadImg: [],
    };
  },
  mounted() {
    this.oid = this.$route.query.oid;
    let orderData = JSON.parse(localStorage.getItem("o_" + this.oid));
    this.orderItems = orderData.orderItems || [];
    this.loadData("001");
    this.loadData("002");
  },
  methods: {
    loadData(entityCode) {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let keys = {
          "001": "showViewData",
          "002": "orderItemShowViewData",
        };
        this.$authAjax
          .post("/comment/record/getCommentItem", {
            entityCode: entityCode,
          })
          .then((res) => {
            let { data } = res.data;
            if (data.entityCode == "001") {
              this.UpdateData.showViewData = data;
            } else {
              this.UpdateData.orderItemShowViewData = data;
            }
          });
      } catch(err) {
        console.log(err);
      }finally {
        this.$toast.clear();
      }
    },
    //改变评分
    onChangeItem(e, item) {
      let index = this.commentItems.findIndex(
        (item1) => item1.code == item.code
      );
      (this.commentItems || []).map((data) => {
        if (data.code == item.code && data.score != e) {
          this.commentItems.splice(index, 1);
        }
      });
      this.commentItems.push({
        code: item.code,
        score: e,
        itemCode: item.code,
      });
    },
    changeOrderItems(e, item1, item) {
      let index = this.orderCommentItems.findIndex(
        (ite) => ite.entityId == item.productId
      );
      (this.orderCommentItems || []).map((data) => {
        if (data.entityId == item.productId) {
          this.orderCommentItems.splice(index, 1);
        }
      });
      this.orderCommentItems.push({
        entityName: item.productName,
        entityId: item.productId,
        commentItems: [
          {
            code: item1.code,
            score: e,
            itemCode: item1.code,
          },
        ],
      });
      console.log(this.orderCommentItems);
    },
    //改变输入框
    changeText(e, item) {
      if (this.commentItems.length == 0) {
        this.commentItems.push({
          code: item.code,
          content: e,
          itemCode: item.code,
        });
      }
      this.commentItems.map((data) => {
        if (data.code == item.code) {
          data.content = e;
        }
      });
    },
    //上传图片
    changeUploadImg(e, item) {
      try {
        this.$toast.loading({
          message: "上传中...",
          forbidClick: true,
          duration: 0,
        });
        let orderData = JSON.parse(localStorage.getItem("o_" + this.oid));
        let formData = new FormData();
        formData.append("shopId", orderData.shopId); //orderData.shopId
        formData.append("file", e.file);
        this.$logina
          .post("/api/wxapp/comment/H5/uploadCommentImg", formData)
          .then((res) => {
            let { data } = res;
            console.log(data);
            this.uploadImg.push(data.data.imgUrl);
            this.$toast.clear();
          });
        this.commentItems.map((data) => {
          if (data.code == item.code) {
            data.files = this.uploadImg;
          }
        });
      } catch (err) {
      } finally {
        this.$toast.clear();
      }
    },
    //删除图片
    changeDeleteImg(e, item) {
      console.log(e);
      this.commentItems.map((data) => {
        if (data.code == item.code) {
          this.uploadImg.splice(e, 1);
          data.files.splice(e, 1);
        }
      });
    },
    //提交意见
    handleSubmitEvalue() {
      let orderData = JSON.parse(localStorage.getItem("o_" + this.oid));
      let commTime = until.format(new Date());
      this.commentItems.map((item) => {
        item.commentTime = commTime;
      });
      if (!this.commentItems || !this.commentItems.length) {
        this.$toast("请评价订单");
        return;
      }
      if (!this.orderCommentItems || !this.orderCommentItems.length) {
        this.$toast("请评价菜品");
        return;
      }
      let resData = [];
      resData.push({
        entityCode: "001",
        bizId: {
          "1_merchantId": orderData.shopId || 23,
          "2_branchId": orderData.branchId || 9, // TODO: 等字段中
        },
        entityName: orderData.branchName || this.oid, // TODO: 等字段中
        entityId: this.oid,
        commentUser: orderData.customerId,
        commentUserName: orderData.customerName,
        commentItems: this.commentItems,
      });
      this.orderCommentItems.map((item) => {
        item.commentItems[0].commentTime = until.format(new Date());
        resData.push({
          entityCode: "002",
          entityName: item.entityName,
          entityId: item.entityId,
          commentUser: orderData.customerId,
          commentUserName: orderData.customerName,
          commentItems: item.commentItems,
          bizId: {
            "1_merchantId": orderData.shopId,
            "2_branchId": orderData.branchId || 9,
            "3_orderNo": this.oid,
            "4_productId": item.entityId,
          },
        });
      });
      console.log(resData, "resData");
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      this.$authAjax
        .post("/comment/record/batchAddCommentRecord", resData)
        .then((res) => {
          let { data } = res;
          console.log(data, "data");
          if (data.code == 200) {
            this.$toast.clear();
            this.$toast("提交成功");
            setTimeout(() => {
              this.$router.back();
            }, 1000);
          } else {
            this.$toast.clear();
            this.$toast(data.message || "未知错误");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.evalue-main {
  width: 100%;
  height: 100vh;
  background: #f7f8fa;
  padding: 14px 14px 120px 14px;
  box-sizing: border-box;
  overflow: auto;
  .order-evalue {
    width: 343px;
    min-height: 400px;
    background: #fff;
    border-radius: 8px;
    padding: 10px;
    box-sizing: border-box;
    .orderTitle {
      font-size: 17px;
    }
  }

  .menu-evalue {
    margin-top: 16px;
    width: 343px;
    min-height: 100px;
    background: #fff;
    border-radius: 8px;
    padding: 10px;
    box-sizing: border-box;
    .order-item-info {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .order-item-title {
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      .order-item-money {
        color: rgb(199, 13, 13);
        line-height: 1.2;
      }
      .order-item-quantity {
        color: #666;
        line-height: 1;
      }
    }
  }
  .submit-bottom {
    width: 100%;
    padding: 12px;
    background: #f7f8fa;
    position: fixed;
    left: 0;
    bottom: 0;
    .submit-btn {
      width: 343px;
      height: 50px;
      background: #2ab0e7;
      color: #fff;
      text-align: center;
      line-height: 50px;
      margin: auto;
      border-radius: 25px;
      font-size: 18px;
    }
  }
}
</style>